export default __webpack_public_path__ + "static/media/secondary.018bfcb1c2e13c6c09890739ee26273b.svg";